// src/components/community/CommentForm.js
import React, { useState, useEffect, useRef } from 'react';
import "./Comments.css";

const CommentForm = ({ 
  onSubmit, 
  onCancel, 
  initialValue = '',
  placeholder = 'Write a comment...', 
  submitButtonText = 'Submit'
}) => {
  const [content, setContent] = useState(initialValue);
  const isMounted = useRef(true);
  
  // Set up mounted ref
  useEffect(() => {
    isMounted.current = true;
    return () => {
      isMounted.current = false;
    };
  }, []);

  // Update content if initialValue changes (for editing)
  useEffect(() => {
    if (isMounted.current) {
      setContent(initialValue);
    }
  }, [initialValue]);

  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (!isMounted.current) return;
    
    if (content.trim()) {
      onSubmit(content);
      // Only clear if not editing (when initialValue is empty)
      if (!initialValue && isMounted.current) {
        setContent('');
      }
    }
  };

  const handleCancel = () => {
    if (isMounted.current && onCancel) {
      onCancel();
    }
  };

  return (
    <form className="comment-form" onSubmit={handleSubmit}>
      <textarea
        className="comment-textarea"
        placeholder={placeholder}
        value={content}
        onChange={(e) => isMounted.current && setContent(e.target.value)}
        required
        autoFocus={!!initialValue} // Auto-focus when editing
      />
      
      <div className="comment-form-actions">
        {onCancel && (
          <button 
            type="button"
            className="cancel-comment"
            onClick={handleCancel}
          >
            Cancel
          </button>
        )}
        
        <button 
          type="submit"
          className="submit-comment"
          disabled={!content.trim()}
        >
          {submitButtonText}
        </button>
      </div>
    </form>
  );
};

export default CommentForm;